import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  IconButton,
  Button,
  Grid,
  Tooltip,
  Chip,
  CircularProgress,
  Paper,
  Tabs,
  Tab
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import LimitModal from '../Buy Module/LimitModal';
import SubscriptionModal from '../Buy Module/SubscriptionModal';
import AlertModal from '../Buy Module/AlertModal';
import {
  FavoriteBorder,
  Favorite,
  Share,
  Chat,
  ThumbUpAltOutlined,
  ThumbUpAlt,
  Call,
  LocationOn,
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';
import axios from 'axios';
import buildingImage from './../../../Images/house.jpeg';
import CustomSearchBar from './../Lease Module/CustomSearch';
import BottomNavbar from './../Post Module/FormsBottomNavbar';

import { BASE_URL } from './../../Api/ApiUrls';
import { AuthContext } from './../../AuthContext/AuthContext';
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';

const PostBank_detail = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [saved, setSaved] = useState(() => {
    const stored = localStorage.getItem('saveRent');
    return stored ? JSON.parse(stored) : [];
  });
  const [likedCards, setLikedCards] = useState({});
  const [properties, setProperties] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [selectedType, setSelectedType] = useState(null);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const { userId, logout } = useContext(AuthContext);
  const [savedProperties, setSavedProperties] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [saving, setSaving] = useState({});
  const [priceFilter, setPriceFilter] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [userActivities, setUserActivities] = useState([]);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [featureRequested, setFeatureRequested] = useState('');
  const [locationLoading, setLocationLoading] = useState({});
  const [userPlan, setUserPlan] = useState(null);
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [currentPropertyId, setCurrentPropertyId] = useState(null);
  const [activeTab, setActiveTab] = useState('auction');
const [showSuccess, setShowSuccess] = useState(false);
const [showFailure, setShowFailure] = useState(false);
const [showNotRemoved, setShowNotRemoved] = useState(false);
const [alertMessage, setAlertMessage] = useState("");

  const BANK_API = `${BASE_URL}/auction-property/`;

  const handlePriceFilterChange = (range) => {
    setPriceFilter(range);
  };

  const rentalTypes = [
    "PLOT", "LAND", "COMMERCIAL LAND/PLOT", "RENT WITH DUPLEX BUILDING", "DUPLEX HOUSE",
    "RENTAL BUILDING", "PG-OFFICES", "FLAT", "VILLA",
    "COMMERCIAL BUILDING", "APARTMENT", "JV/JD"
  ];

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.post(`${BASE_URL}/bank-properties/filter/`, {
        include: {
          status: "Approved",   // ✅ filter in backend
        },
        exclude: {},
      });

      console.log("API Response:", res.data);

      // ✅ HANDLE RESPONSE STRUCTURE
      const rawData = res.data;

      const list = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData.data)
          ? rawData.data
          : [];

      // ❌ NO FRONTEND FILTER HERE
      const parsed = list.map(item => {
        let images = [];

        if (item.bank_pro_doc && item.bank_pro_doc.length > 0) {
          images = item.bank_pro_doc.map(doc => {
            const path = doc.document;

            if (!path) return null;

            if (path.startsWith("http")) return path;
            if (path.startsWith("/")) return `${BASE_URL}${path}`;

            return null;
          }).filter(Boolean);
        }

        if (images.length === 0) {
          images = [buildingImage];
        }

        return {
          id: item.bankprop_id,
          title: item.property_type || "Auction Property",
          location: item.location || "Not specified",
          city_town: item.city_town || "Not specified",
          price: `₹${parseInt(item.reserve_price || 0).toLocaleString()}`,
          reserve_price: parseFloat(item.reserve_price || 0),

          images,
          propertyData: item,

          bank_name: item.bank_name,
          auction_start: item.auction_start_datetime,
          auction_end: item.auction_end_datetime,
          status: item.status,
        };
      });

      setProperties(parsed);

    } catch (error) {
      console.error("Error fetching bank properties:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);
  
  const handleNextImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId] || 0;
      const property = properties.find(p => p.id == propertyId);
      if (!property || !property.images || property.images.length === 0) {
        return prev;
      }
      const nextIndex = (currentIndex + 1) % property.images.length;
      console.log('Next image for property', propertyId, ':', nextIndex);
      return {
        ...prev,
        [propertyId]: nextIndex
      };
    });
  };

  const handlePrevImage = (propertyId, e) => {
    e.stopPropagation();
    setCurrentImageIndex(prev => {
      const currentIndex = prev[propertyId] || 0;
      const property = properties.find(p => p.id == propertyId);
      if (!property || !property.images || property.images.length === 0) {
        return prev;
      }
      const prevIndex = (currentIndex - 1 + property.images.length) % property.images.length;
      console.log('Previous image for property', propertyId, ':', prevIndex);
      return {
        ...prev,
        [propertyId]: prevIndex
      };
    });
  };

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        console.log('Checking subscription for user:', userId);
        const response = await axios.get(`${BASE_URL}/Get-user-plan/${userId}/`);
        const subscriptions = response.data;

        console.log('Found subscriptions:', subscriptions);

        const tenantSubscription = Array.isArray(subscriptions) 
          ? subscriptions.find(sub => sub.user_type === "Tenant")
          : null;

        if (tenantSubscription) {
          console.log('User has a Tenant subscription');
          setIsSubscribed(true);
          setUserPlan(tenantSubscription);
        } else {
          console.log('User does NOT have a Tenant subscription');
          setIsSubscribed(false);
          setUserPlan(null);
        }
      } catch (error) {
        console.error('Error checking subscription:', error);
        setIsSubscribed(false);
        setUserPlan(null);
      }
    };

    if (userId) {
      checkSubscription();
    } else {
      console.log('No user ID, defaulting to non-subscribed state');
      setIsSubscribed(false);
      setUserPlan(null);
    }
  }, [userId]);

  useEffect(() => {
    const fetchUserActivities = async () => {
      if (!userId) {
        console.log('No userId - skipping activity fetch');
        return;
      }
      
      try {
        console.log(`Fetching activities for user ${userId}`);
        const response = await fetch(`${BASE_URL}/activities/`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const allActivities = await response.json();
        console.log('All activities from API:', allActivities);
        
        const filteredActivities = allActivities.filter(activity => {
          if (!activity || activity.user_id === undefined) {
            console.warn('Invalid activity object:', activity);
            return false;
          }
          
          return String(activity.user_id) === String(userId);
        });
        
        console.log('Filtered user activities:', filteredActivities);
        setUserActivities(filteredActivities);
        
      } catch (error) {
        console.error('Error fetching activities:', error);
        setUserActivities([]);
      }
    };
 
    fetchUserActivities();
  }, [userId]);

  const checkPropertyLimit = (currentPropertyId) => {
    if (!isSubscribed) {
      console.log('Non-subscriber - access denied');
      setFeatureRequested("Property Access");
      setShowSubscribeModal(true);
      return false;
    }

    if (userPlan?.no_of_properties_unlimited) {
      console.log('User has unlimited property access');
      return true;
    }

    const propertyActivities = userActivities.filter(
      activity => activity.activity_as === "Tenant" && 
                activity.property_id === currentPropertyId
    );

    if (propertyActivities.length > 0) {
      console.log('Property already accessed - allowing action');
      return true;
    }

    const tenantActivities = userActivities.filter(
      activity => activity.activity_as === "Tenant"
    );
    const uniqueProperties = new Set(tenantActivities.map(a => a.property_id));

    const propertyLimit = userPlan?.no_of_properties || 10;

    if (uniqueProperties.size >= propertyLimit) {
      console.log(`Property limit (${propertyLimit}) exceeded - showing limit modal`);
      setShowLimitModal(true);
      return false;
    }

    return true;
  };

  const logActivity = async (propertyId, activityType) => {
    const existingActivity = userActivities.find(
      activity => activity.property_id === propertyId && 
                activity.activity_as === "Tenant"
    );

    if (existingActivity) {
      console.log('Activity already exists for this property');
      return false;
    }

    const property = properties.find(p => p.id === propertyId);

    if (!property) {
      console.error('Property not found for logging activity');
      return false;
    }

    const postData = {
      user_id: userId,
      property_id: propertyId,
      activity_type: activityType,
      property_by: property.owner,
      activity_as: "Tenant"
    };

    console.log('Posting activity data:', postData);

    try {
      const response = await fetch(`${BASE_URL}/activities/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Failed to log activity:', errorData);
        throw new Error(errorData.message || 'Failed to log activity');
      }

      const newActivity = await response.json();
      console.log('Activity logged successfully:', newActivity);
      setUserActivities(prev => [...prev, newActivity]);
      return true;
    } catch (err) {
      console.error("Error logging activity:", err);
      return false;
    }
  };

  const handleAction = async (e, propertyId, actionName, actionCallback, activityType) => {
    e.stopPropagation();

    if (!isSubscribed) {
      setFeatureRequested(actionName);
      setShowSubscribeModal(true);
      return;
    }

    const alreadyAccessed = userActivities.some(
      activity => activity.property_id === propertyId && 
                activity.activity_as === "Tenant"
    );

    if (!alreadyAccessed) {
      const withinLimit = checkPropertyLimit(propertyId);
      if (!withinLimit) {
        return;
      }
    }

    setPendingAction(() => async () => {
      try {
        await actionCallback();

        if (activityType && !alreadyAccessed) {
          await logActivity(propertyId, activityType);
        }
      } catch (error) {
        console.error(`Error in ${actionName} action:`, error);
        alert(`Failed to complete ${actionName} action`);
      }
    });

    setCurrentPropertyId(propertyId);
    setShowAlertModal(true);
  };

const handleCallClick = (e, property) => {
  handleAction(
    e,
    property.id,
    "Call",
    async () => {
      try {
        await navigator.clipboard.writeText(property.mobile_no);

        setAlertMessage(`Phone number copied: ${property.mobile_no}`);
        setShowSuccess(true);

      } catch (error) {
        console.error("Copy failed:", error);

        setAlertMessage("Failed to copy phone number");
        setShowFailure(true);
      }
    },
    "Call"
  );
};

  const handleLocationClick = (e, property) => {
    handleAction(e, property.id, "Location", async () => {
      setLocationLoading(prev => ({ ...prev, [property.id]: true }));
      
      const openInMaps = (url) => {
        setLocationLoading(prev => ({ ...prev, [property.id]: false }));
        window.open(url, '_blank', 'noopener,noreferrer');
      };

      const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(property.location)}`;
      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;
            const mapsUrl = property.lat && property.long
              ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.long}&travelmode=driving`
              : fallbackUrl;
            openInMaps(mapsUrl);
          },
          (error) => {
            console.error("Error getting location:", error);
            openInMaps(fallbackUrl);
          },
          { timeout: 10000 }
        );
      } else {
        openInMaps(fallbackUrl);
      }
    }, "Location");
  };

  const getAccessedProperties = () => {
    const tenantActivities = userActivities.filter(
      activity => activity.activity_as === "Tenant"
    );
    
    const uniquePropertyIds = [...new Set(tenantActivities.map(activity => activity.property_id))];
    return properties.filter(property => uniquePropertyIds.includes(property.id));
  };

  const filteredProperties = activeTab === 'accessed'
    ? getAccessedProperties()
    : properties.filter((property) => {
      const matchesSearch =
        (property.title && property.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (property.location && property.location.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (property.city_town && property.city_town.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (property.area_town && property.area_town.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (property.bank_name && property.bank_name.toLowerCase().includes(searchQuery.toLowerCase()));

      const matchesType = selectedType
        ? (property.title && property.title.toLowerCase().includes(selectedType.toLowerCase())) ||
          (property.property_name && property.property_name.toLowerCase().includes(selectedType.toLowerCase()))
        : true;

      const matchesPrice = priceFilter
        ? property.reserve_price >= priceFilter.min &&
          property.reserve_price <= priceFilter.max
        : true;

      return matchesSearch && matchesType && matchesPrice;
    });

  if (loading) {
    return (
      <Box sx={{ 
        backgroundColor: 'rgb(239, 231, 221)', 
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Typography>Loading auction properties...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: 'rgb(239, 231, 221)', minHeight: '120vh', pb: 8 }}>
      {/* Sticky Search Bar - Keep only this header */}
      <Box
        sx={{
            position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
          px: 1,
          py: 1,
          backgroundColor: 'rgb(239, 231, 221)',
        }}
      >
        <CustomSearchBar 
          value={searchQuery} 
          onChange={(e) => setSearchQuery(e.target.value)}
          onPriceFilterChange={handlePriceFilterChange}
        />


   
      {/* Property Types - Only show when in 'auction' tab */}
      {activeTab === 'auction' && (
        <Box sx={{ px: 2,mt: 2 }}>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              pb: 1,
            }}
          >
            {rentalTypes.map((type, index) => (
              <Chip
                key={index}
                label={type}
                variant="filled"
                onClick={() => setSelectedType(prev => (prev === type ? null : type))}
                sx={{
                  flexShrink: 0,
                  bgcolor: selectedType === type ? '#000000' : 'transparent',
                  color: selectedType === type ? '#ffffff' : '#000000',
                  border: '1px solid black',
                  fontWeight: 'bold',
                  '&:hover': {
                bgcolor: selectedType === type ? '#000000' : 'transparent',
                color: selectedType === type ? '#ffffff' : '#000000',
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      )}
      </Box>
      {/* Property Cards List */}
      <Box   sx={{
        pt: { xs: '100px', sm: '150px' }, 
      }}>
        {filteredProperties.length > 0 ? (
          filteredProperties.map((property) => {
            const isAccessed = userActivities.some(activity => 
              activity.property_id === property.id && activity.activity_as === "Tenant"
            );

            // Format auction dates
            const auctionStart = property.auction_start ? 
              new Date(property.auction_start).toLocaleString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              }) : 'Not scheduled';
            
            const auctionEnd = property.auction_end ? 
              new Date(property.auction_end).toLocaleString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              }) : 'Not specified';

            const currentIndex = currentImageIndex[property.id] || 0;
            const propertyImages = property.images || [buildingImage];
            const currentImage = propertyImages[currentIndex];

            console.log('Rendering property:', property.id, 'Images:', property.images, 'Current index:', currentIndex);

            return (
              <Box key={property.id} sx={{ maxWidth: 900, mx: "auto", p: 2, pb: 1 }}>
                {/* ================= UPPER CARD ================= */}
                <Card
                  sx={{
                    display: "flex",
                    borderRadius: "12px 12px 0 0",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                    overflow: "hidden",
                    bgcolor: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={async (e) => {
                    const isButtonClick = e.target.closest('button') || e.target.closest('svg');
                    if (!isButtonClick) {
                      if (!isSubscribed) {
                        setFeatureRequested("View Details");
                        setShowSubscribeModal(true);
                        return;
                      }

                      const alreadyAccessed = userActivities.some(
                        activity => activity.property_id === property.id && 
                                  activity.activity_as === "Tenant"
                      );

                      if (!alreadyAccessed) {
                        const withinLimit = checkPropertyLimit(property.id);
                        if (!withinLimit) {
                          return;
                        }
                      }

                      if (!alreadyAccessed) {
                        try {
                          await logActivity(property.id, "Description");
                        } catch (error) {
                          console.error('Error logging description view activity:', error);
                        }
                      }

                      navigate(`/Post_Bankcard_indetail/${property.id}`, {  
                        state: { 
                          propertyId: property.id, 
                          property: property.propertyData 
                        } 
                      });
                    }
                  }}
                >
                  <Box sx={{ width: "70%", position: "relative" }}>
                    <CardMedia
                      component="img"
                      height={200}
                      image={currentImage}
                      alt="property"
                      sx={{ width: "100%", height: "230px", objectFit: "cover" }}
                      onError={(e) => {
                        console.error('Image failed to load:', currentImage);
                        e.target.src = buildingImage;
                      }}
                    />
                    
                    {propertyImages.length > 1 && (
                      <>  
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            left: 8,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,1)' }
                          }}
                          onClick={(e) => handlePrevImage(property.id, e)}
                        >
                          <ChevronLeft fontSize="small" />
                        </IconButton>
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: 8,
                            transform: 'translateY(-50%)',
                            backgroundColor: 'rgba(255,255,255,0.8)',
                            backdropFilter: 'blur(2px)',
                            '&:hover': { backgroundColor: 'rgba(255,255,255,1)' }
                          }}
                          onClick={(e) => handleNextImage(property.id, e)}
                        >
                          <ChevronRight fontSize="small" />
                        </IconButton>
                      </>
                    )}

                    {/* Image Dots Indicator */}
                    {propertyImages.length > 1 && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 16,
                          left: '50%',
                          transform: 'translateX(-50%)',
                          display: 'flex',
                          gap: 1
                        }}
                      >
                        {propertyImages.map((_, index) => (
                          <Box
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              setCurrentImageIndex(prev => ({
                                ...prev,
                                [property.id]: index
                              }));
                            }}
                            sx={{
                              width: 8,
                              height: 8,
                              borderRadius: '50%',
                              backgroundColor: currentIndex === index ? '#1976d2' : '#ccc',
                              cursor: 'pointer',
                              transition: 'background-color 0.3s'
                            }}
                          />
                        ))}
                      </Box>
                    )}

                    <Box
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        display: "flex",
                        gap: 1,
                        alignItems: "center",
                      }}
                    >
                      {isAccessed && (
                        <Tooltip title="Already Accessed">
                          <IconButton
                            sx={{
                              bgcolor: "white",
                              boxShadow: 1,
                              p: 0.5,
                              color: "green"
                            }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <CheckCircle fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      width: "30%",
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5, 
                      justifyContent: "space-between",
                    }}
                  >
                   <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    gap: 0.5,   // 👈 controls space between each Typography
  }}
>
  <Typography variant="subtitle2" color="text.secondary">
    Reserve Price
  </Typography>

  <Typography fontSize={16} fontWeight={700} color="primary">
    {property.price}
  </Typography>

  <Typography variant="caption" color="text.secondary">
    Posted:{" "}
    {new Date(property.date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })}
  </Typography>
</Box>

              <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    gap: 0.6,
  }}
>
  <Button
    variant="outlined"
    startIcon={
      <Call sx={{ transform: "scale(0.8)" }} />
    }
    sx={{
      color: "green",
      borderColor: "green",
      py: 0.5,
      fontSize: "0.65rem",
      textTransform: "none",
      justifyContent: "flex-start",
      minHeight: "30px",
    }}
    onClick={(e) => handleCallClick(e, property)}
  >
    Call
  </Button>

  <Button
    variant="outlined"
    startIcon={
      <LocationOn sx={{ transform: "scale(0.8)" }} />
    }
    sx={{
      color: "#1976d2",
      borderColor: "#1976d2",
      py: 0.5,
      fontSize: "0.65rem",
      textTransform: "none",
      justifyContent: "flex-start",
      minHeight: "30px",
    }}
    onClick={(e) => handleLocationClick(e, property)}
    disabled={locationLoading[property.id]}
  >
    {locationLoading[property.id] ? (
      <CircularProgress size={14} />
    ) : (
      "Location"
    )}
  </Button>
</Box>


                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 0.2 }}
                      >
                        Area
                      </Typography>
                      <Typography fontWeight={600} variant="body1">
                        {property.area || "N/A"}
                      </Typography>
                    </Box>
                  </Box>
                </Card>

         <Card sx={{ 
  borderRadius: "0 0 12px 12px", 
  mt: "-15px", 
  p: 2,
  bgcolor: '#f9f9f9'
}}>
  <Grid container spacing={1.3}>
    {/* Row 1: Two columns */}
    <Grid item xs={12} container spacing={1.2}>
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Property ID :
          </Typography>
          <Typography variant="body2">
            {property.id} 
          </Typography>
        </Box>
      </Grid>
        <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Property Type:
          </Typography>
          <Typography variant="body2">
            {property.property_name}
          </Typography>
        </Box>
      </Grid>
      
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Bank & Location:
          </Typography>
        <Typography variant="body2">
  {(property.bank_name + ' - ' + property.city_town).length > 20
    ? (property.bank_name + ' - ' + property.city_town).slice(0, 20) + '...'
    : property.bank_name + ' - ' + property.city_town}
</Typography>

        </Box>
      </Grid>
    </Grid>

    {/* Row 2: Two columns */}
    <Grid item xs={12} container spacing={1.2}>
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Auction Type:
          </Typography>
          <Typography variant="body2">
            {property.action_type || 'N/A'}
          </Typography>
        </Box>
      </Grid>
      
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            EMD Amount:
          </Typography>
          <Typography variant="body2">
            ₹{(property.emd_amount || 0).toLocaleString()}
          </Typography>
        </Box>
      </Grid>
    </Grid>

    {/* Row 3: Two columns */}
    <Grid item xs={12} container spacing={1.2}>
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Auction Start:
          </Typography>
          <Typography variant="body2">
            {auctionStart}
          </Typography>
        </Box>
      </Grid>
      
      <Grid item xs={12} md={5}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
            Bid Increment:
          </Typography>
          <Typography variant="body2">
            ₹{(property.bid_increment || 0).toLocaleString()}
          </Typography>
        </Box>
      </Grid>
    </Grid>

    {/* Row 4: Single full-width column for possession */}
    <Grid item xs={12}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', minWidth: '120px' }}>
          Possession:
        </Typography>
        <Typography variant="body2">
          {property.possession_status || 'N/A'}
        </Typography>
      </Box>
    </Grid>
  </Grid>
</Card>
              </Box>
            );
          })
        ) : (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
            px: 2
          }}>
            {activeTab === 'accessed' ? (
              <Typography>You haven't accessed any auction properties yet</Typography>
            ) : selectedType ? (
              <Typography>
                No auction properties listed in the "{selectedType}" category
              </Typography>
            ) : (
              <Typography>No auction properties found matching your search.</Typography>
            )}
          </Box>
        )}
      </Box>

      {/* Alert Modal */}
      <AlertModal
        open={showAlertModal}
        onClose={() => setShowAlertModal(false)}
        onConfirm={async () => {
          setShowAlertModal(false);
          if (pendingAction) {
            await pendingAction();
          }
        }}
        title="Confirm Action"
        message={`Are you sure you want to perform this action on this auction property?`}
      />

      {/* Subscription Modal */}
      <SubscriptionModal
        open={showSubscribeModal}
        onClose={() => setShowSubscribeModal(false)}
        onSubscribe={() => {
          setShowSubscribeModal(false);
          navigate('/user-subscription');
        }}
        featureRequested={featureRequested}
      />

      {/* Limit Modal */}
      <LimitModal
        open={showLimitModal}
        onClose={() => setShowLimitModal(false)}
        userPlan={userPlan}
      />


{showSuccess && (
  <CopySuccessAlert
    message={alertMessage}
    onClose={() => {
      setShowSuccess(false);
      setAlertMessage(""); // Clear message when closing
    }}
  />
)}


{showFailure && (
  <CopyFailureAlert
    message={alertMessage}
    onClose={() => {
      console.log("Closing failure alert");
      setShowFailure(false);
      setAlertMessage("");
    }}
  />
)}
      {/* Bottom Navbar */}
      <BottomNavbar />
    </Box>
  );
};

export default PostBank_detail;